import { $themeColors } from "@themeConfig";
// colors
export const chartColors = {
  tooltipShadow: "rgba(0, 0, 0, 0.25)",
  lineChartPrimary: "#8d5185",
  labelColor: "#6e6b7b",
  grid_line_color: "rgba(200, 200, 200, 0.2)",
};

export const defaultDataset = {
  data: [],
  label: "",
  borderColor: chartColors.lineChartPrimary,
  lineTension: 0.5,
  pointStyle: "circle",
  backgroundColor: chartColors.lineChartPrimary,
  fill: false,
  pointRadius: 1,
  pointHoverRadius: 5,
  pointHoverBorderWidth: 5,
  pointBorderColor: "transparent",
  pointHoverBorderColor: "#fdfdfd",
  pointHoverBackgroundColor: chartColors.lineChartPrimary,
  pointShadowOffsetX: 1,
  pointShadowOffsetY: 1,
  pointShadowBlur: 5,
  pointShadowColor: chartColors.tooltipShadow,
};

export default {
  lineChart: {
    options: {
      responsive: true,
      maintainAspectRatio: false,
      backgroundColor: false,
      hover: {
        mode: "label",
      },
      tooltips: {
        // Updated default tooltip UI
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowBlur: 8,
        shadowColor: chartColors.tooltipShadow,
        backgroundColor: "#fdfdfd",
        titleFontColor: "#2f2f2f",
        bodyFontColor: "#2f2f2f",
      },
      layout: {
        padding: {
          top: -15,
          bottom: -25,
          left: -15,
        },
      },
      scales: {
        xAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
            },
            gridLines: {
              display: true,
              color: chartColors.grid_line_color,
              zeroLineColor: chartColors.grid_line_color,
            },
            ticks: {
              fontColor: chartColors.labelColor,
            },
          },
        ],
        yAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
            },
            ticks: {
              // stepSize: 10,
              min: 0,
              // max: 400,
              fontColor: chartColors.labelColor,
            },
            gridLines: {
              display: true,
              color: chartColors.grid_line_color,
              zeroLineColor: chartColors.grid_line_color,
            },
          },
        ],
      },
      legend: {
        display: false,
        position: "top",
        align: "start",
        labels: {
          usePointStyle: true,
          padding: 25,
          boxWidth: 9,
        },
      },
    },
    data: {
      labels: [],
      datasets: [defaultDataset],
    },
  },
  pieChart: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      responsiveAnimationDuration: 500,
      legend: { display: true },
      pieceLabel: {
        mode: "percentage",
        precision: 1,
      },
      tooltips: {
        callbacks: {
          label(tooltipItem, data) {
            const label = data.datasets[0].labels[tooltipItem.index] || "";
            const value = data.datasets[0].data[tooltipItem.index];
            const output = ` ${label} : ${value} %`;
            return output;
          },
        },
        // Updated default tooltip UI
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowBlur: 8,
        shadowColor: chartColors.tooltipShadow,
        backgroundColor: $themeColors.light,
        titleFontColor: $themeColors.dark,
        bodyFontColor: $themeColors.dark,
      },
    },
    data: {
      datasets: [
        {
          labels: [],
          data: [],
          backgroundColor: [
            "#8d5185",
            "#27ae60",
            "#2980b9",
            "#ffc107",
            "#c0392b",
          ],
          borderWidth: 0,
          pointStyle: "rectRounded",
        },
      ],
    },
  },
};
